import { connect } from 'react-redux';

import Select from '../../components/Inputs/Select';

const mapStateToProps = (state, props) => {
  const [store, ...storeKey] = props.storeKey.split('.');
  storeKey.push('value');
  return ({
    value: state[store].getIn(storeKey),
  });
};

export default connect(mapStateToProps)(Select);
